export default __webpack_public_path__ + "static/media/Lavanika.5e36150b.png";